<mat-card class="p-0 artstuff-datepicker-panel">
    <button mat-button color="primary" disableRipple="true" class="btn-timerange">
        {{ 'TIME_RANGE.ELECTIVE' | translate }}
    </button>
    <button *ngFor="let item of customPresets" mat-button color="primary" class="w-100-p pl-24" (click)="selectRange(item)">
        {{ 'TIME_RANGE.' + item | translate }}
    </button>
</mat-card>
